import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 0 -1px 2px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    text-align: left;\n    text-decoration: none;\n    background-color: transparent;\n    cursor: pointer;\n    ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n        text-decoration: underline;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n        ", ";\n        font-weight: ", ";\n        ", ";\n\n        &:hover,\n        &:focus {\n            color: ", ";\n        }\n\n        &:active {\n            color: ", ";\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { typography, transitions } from '../mixins';
import { CurvedArrowIcon } from '../icons';

var themedStyles = function themedStyles(_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  var _theme$palette$color = theme.palette[color],
      main = _theme$palette$color.main,
      hover = _theme$palette$color.hover,
      active = _theme$palette$color.active;
  return css(_templateObject(), main, typography(size === 'medium' ? 'body1' : 'body2'), theme.typography.action.fontWeight, transitions(['color']).easeOut().shortest(), hover, active);
};

var StyledLink = styled.a(_templateObject2(), themedStyles);
var ExternalLinkArrow = styled(CurvedArrowIcon)(_templateObject3());
export var Link = React.forwardRef(function (_a, ref) {
  var component = _a.component,
      _a$external = _a.external,
      external = _a$external === void 0 ? false : _a$external,
      children = _a.children,
      props = __rest(_a, ["component", "external", "children"]);

  var relProp = external && props.target === '_blank' ? {
    rel: 'noopener noreferrer'
  } : {};
  return React.createElement(StyledLink, Object.assign({}, props, relProp, component && {
    as: component
  }, {
    ref: ref
  }), children, external && React.createElement(ExternalLinkArrow, {
    viewBox: '0 0 12 10',
    width: 12,
    height: 10
  }));
});
Link.displayName = 'Link';